/**
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "App";

const container = document.getElementById("root");

const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

// Always client-render. Pre-rendered HTML from react-snap is for SEO only
// (search engines see the static content). React 18's strict hydration
// produces false-positive #418/#423 errors with MUI/Emotion CSS-in-JS,
// so we skip hydration and render fresh — no visual difference since
// react-snap hides #root with opacity:0 until JS takes over.
ReactDOM.createRoot(container).render(app);
